<div class="drag">
  <ui-inline-svg name="drag" class="drag-icon"></ui-inline-svg>
</div>
